import Backbone from 'backbone'
import template from './values-form.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import NotesDialog from 'scoreboard/notes/notes-dialog'
import MarkedField from 'scoreboard/components/marked-field'
import config from 'scoreboard/components/config'
import calendars from 'scoreboard/components/calendars'
import $ from 'jquery'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import FormView from 'scoreboard/components/form-view'
import appDisplay from 'scoreboard/components/app-display'
import formatValue from 'scoreboard/components/format-value'
import select from 'scoreboard-select'
import deviceType from 'scoreboard/components/device-type'
import permissions from 'scoreboard/components/permissions'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import globals from 'scoreboard/components/globals'
import { setupUnapprovedValues, hasUnapprovedValues }
	from 'scoreboard/scorecards/metrics/unapproved-metrics'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

/**
 * A private method which toggles the applicable styling of the row.
 */
function toggleApplicable(row, applicable) {
	row.toggleClass('not-applicable', !applicable)

	// show input boxes if applicable.  hide otherwise
	let actualCell = row.find('.actual')
	if (!applicable) {
		// destroy tooltips
		var view = actualCell.find('input, select').data('view')
		view && view.removeTooltip()
	}
}

function markField(el, dataType, currencyCode) {
	return new MarkedField({
		el: el,
		evaluator: numericEvaluator,
		validator: numericValidator,
		dataType: dataType,
		currencyCode: currencyCode,
		resizeWithText: true
	}).render()
}

var ValuesForm = Backbone.View.extend({

	// this.model is a ScorecardNode

	tagName: 'form',

	className: 'container values-form form',

	events: {
		'change [name=applicable]': 'toggleApplicable',
		'click .add-note': 'addNote'
	},

	initialize: function() {
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		var ctx = this.context()

		this.$el.html(template(ctx))

		// secure before marking fields so that inputs can be removed for
		// calculated series
		this.secure()

		// wrap everything as a marked field (BEFORE toggling applicable)
		this._markedFields = []
		_.each(this.$('input[type=text]'), el => {
			var field = markField(el, this.model.get('dataType'), this.model.get('currencyCode'))
			this._markedFields.push(field)
		})

		process.nextTick(function() {
			// resize each field so that long input values can be shown (#5239)
			// we have to do this on the next tick or we won't be able to read
			// the input and text sizes to know if we need to expand the boxes
			_.each(this._markedFields, function(field) {
				field.resize()
			})
			if (!deviceType.touchOnly) {
				_.result(this.$('input[type=text]').get(0), 'focus')
			}
		}.bind(this))

		// handle not-applicable rows
		this.toggles = []
		this.$('tbody tr').each((index, el) => {
			// #51712 the DEFAULT_APPLICABLE_STATUS in the app is true, so
			// only consider applicable to be false if it is specifically set
			let isNA = ctx.scores[index]?.unapprovedApplicable === false
			let applicable = !isNA
			let toggle = new OnOffToggle({
				name: 'applicable',
				checked: !applicable
			}).render()
			this.$(el).find('.toggle').append(toggle.el)
			toggleApplicable($(el), applicable)
			this.toggles.push(toggle)
		})

		// handle yes/no and custom text metrics
		this.$('.actual select').each((index, element) => {
			var periodId = this.model.get('actualAndThresholdValuePeriodIds')[index]
			var score = this.model.score(periodId)
			var actual = score && score.unapprovedActual
			var val = null
			if (actual != null) {
				if (_.isNumber(actual)) {
					val = actual
				} else if (actual === 'false') {
					val = 'false'
				} else if (actual === '') {
					val = null
				} else {
					val = actual ? 'true' : 'false'
				}
			}
			this.$(element).val(val)
		})

		this.noteIcons(ctx)

		this.formView.start()

		select(this.el.querySelectorAll('select'))

		return this
	},

	context: function() {
		var ctx = this.model.toJSON()
		ctx.yesNo = this.model.get('dataType') === YES_NO
		ctx.scoringType = config.scoringType(this.model.get('scoringTypeId'))

		var thresholdCount = ctx.series.length - 1
		var blankThresholds = []
		while (thresholdCount > 0) {
			blankThresholds.push('')
			thresholdCount--
		}

		ctx.scores = _.map(this.model.get('actualAndThresholdValuePeriodIds'), function(id) {
			var score = this.model.score(id)
			if (!score) {
				score = { periodId: id, applicable: true }
				var scoringType = config.scoringType(this.model.get('scoringTypeId'))
				if (scoringType.thresholdNames) {
					score.thresholds = []
					_.each(scoringType.thresholdNames, function() {
						score.thresholds.push(null)
					})
				} else {
					score.thresholds = blankThresholds
				}
			}
			score.periodLabel = calendars.periodsById[id].label

			setupUnapprovedValues(score)
			// #24350 If we have any updated values that haven't been approved yet,
			// display a banner and highlight the relevant rows, but only if the config
			// option for this is on
			if (hasUnapprovedValues(score)) {
				score.unapprovedValues = true
				ctx.showUnapprovedValuesBanner = true
			}

			return score
		}.bind(this))

		ctx.showMoreInfoBanner = ctx.scores.length < 2
		ctx.showBanner = ctx.showMoreInfoBanner || ctx.showUnapprovedValuesBanner

		return ctx
	},

	noteIcons: function (ctx) {
		ctx = ctx || this.context()

		// color notes icons appropriately
		var hasNotes = _.transform(this.model.get('notes'), function(result, note) {
			result[note.periodId] = true
		})

		this.$('.icon-note').removeClass('has-notes')
		_.each(ctx.scores, function(score, index) {
			if (hasNotes[score.periodId]) {
				this.$(`[data-period-id="${score.periodId}"] .icon-note`).addClass('has-notes')
			}
		}.bind(this))
	},

	secure: function() {
		let applicableColumn = this.$('.applicable-cell, .applicable-header-cell')
		// secure the actual input if required
		if (!this.model.get('updateActual') ||
			!_.isEmpty(this.model.get('series')[0].equation)) {
			this.secureControls(this.$('.actual input, .actual select'))
			applicableColumn.hide()
		}

		// secure the thresholds if required
		if (!this.model.get('updateThresholds')) {
			this.secureControls(this.$('.threshold input'))
		} else {
			_.forEach(_.tail(this.model.get('series')), function(series, index) {
				if (!_.isEmpty(series.equation)) {
					this.secureControls(this.$('.threshold' + index + ' input'))
				}
			}.bind(this))
		}

		// hide the N/A option if it's not allowed
		if (!config.showNaOption) {
			applicableColumn.addClass('is-not-displayed')
		}

		// secure notes if user does not have appropriate permissions
		var modifyNotes = permissions.structure(this.model.get('orgId')) || permissions.notes(this.model.get('orgId'))
		if (!modifyNotes) {
			this.$('icon-note-header, .icon-note').remove()
		}
	},

	// turns form controls (selects, inputs) into plain text instead
	secureControls: function(elements) {
		_.each(elements, function(el) {
			el = this.$(el)
			var val = formatValue({
				value: el.val(),
				dataType: this.model.get('dataType'),
				currencyCode: this.model.get('currencyCode'),
				precision: this.model.get('precision')
			})
			el.after('<span class="value">' + val + '<span>')
			// record the unshortened value as data attached to the value element
			el.siblings().eq(0).data('value', el.val())
			el.remove()
		}.bind(this))
	},

	// toggles whether the metric values for a particular period are applicable
	toggleApplicable: function(e) {
		let target = this.$(e.target) // the row's on/off toggle
		var row = target.closest('tr')
		// set applicable to whether there is the not-applicable class there,
		// which effectively reverses the previous value
		toggleApplicable(row, !target.is(':checked'))
		this.formView.change(e)
	},

	submit: function(e) {
		var periodIds = this.model.get('actualAndThresholdValuePeriodIds')
		var scores = []
		// update model with new actual values
		_.each(this.$('tbody tr'), function(row, index) {
			// get ready
			var periodId = periodIds[index]
			var score = _.cloneDeep(this.model.score(periodId)) || { periodId: periodId }
			var id = this.model.id
			if (this.model.get('type') === 'linked') {
				id = this.model.get('sourceId')
			}
			score.scorecardItemId = id
			scores.push(score)

			// read actual
			score.unapprovedApplicable = !this.$(row).hasClass('not-applicable')
			// #14516 don't try to read the actual from the form if it's based
			// on an equation
			if (score.unapprovedApplicable && _.isEmpty(this.model.get('series')[0].equation)) {
				let scoringType = config.scoringType(this.model.get('scoringTypeId'))
				// #24350 by default, send the values back as unapproved. If the user
				// owns this metric or approvals aren't required, the server will
				// make the appropriate adjustments
				if (this.model.get('dataType') === YES_NO ||
					scoringType.isCustomText) {
					score.unapprovedActual = this.$(row).find('.actual select').val()
				} else {
					var actualControl = this.$(row).find('.actual input')
					score.unapprovedActual = score.unapprovedApplicable && !_.isEmpty(actualControl) ? actualControl.data('view').val() : null
				}
			}

			// read thresholds
			_.each(this.$(row).find('.threshold'), function(td, thresholdIndex) {
				if (!score.unapprovedThresholds) {
					score.unapprovedThresholds = []
				}
				var input = this.$(td).find('input')
				var value
				if (input.length > 0) {
					value = input.data('view').val()
				} else {
					value = this.$(td).find('.value').data('value')
				}
				score.unapprovedThresholds[thresholdIndex] = value
			}.bind(this))
		}.bind(this))

		let queryParams = $.param({
			calendarPeriodId: globals.periodId
		})

		$.ajax({
			method: 'PUT',
			url: `api/scorecards/${this.model.id}/metric-updates?${queryParams}`,
			data: JSON.stringify(scores),
			success: function(response) {
				this.model.setScores(response.scores, response.relatedItems)
				this.trigger('done')
			}.bind(this),
			error: function(xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})

		return scores
	},

	addNote: function(e) {
		const periodId = $(e.target).closest('tr').data('period-id')
		const notesDialog = new NotesDialog({
			model: this.model,
			defaultTime: periodId,
			timeLabel: calendars.periodsById[periodId].label
		})
		notesDialog.on('change:notes', (notes) => {
			this.noteIcons()
			this.formView.change()
		})
		appDisplay.dialog(notesDialog)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, ...this._markedFields, ...this.toggles], 'remove')
	}

})

export default ValuesForm

ValuesForm.__filename__ = 'scorecards/overview/values-form.js'
